<template>
  <div id="firefly" @mouseenter="hovered=true" @mouseleave="hovered=false">
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Firefly',
  components: { },
  props: ['position'],
  data () {
    return {
      hovered: false,
    }
  },
  computed: {
    x () {      
      return `${this.position.x - 12}px`
    },
    y () {
      return `${this.position.y - 12}px`
    }
  }
}
</script>

<style scoped>
#firefly {
  position: absolute;

  top: v-bind(y);
  left: v-bind(x);

  width: 25px;
  height: 25px;

  opacity: 0.5;
}
</style>